import React, { createContext, useContext } from 'react';

const MosqueContext = createContext(null);

export const useMosque = () => useContext(MosqueContext) || {};

export const MosqueProvider = ({ mosque, children }) => {
  const basePath = `/region/${mosque.regency_slug}/${mosque.village_slug}/${mosque.slug}`;
  const to = (path) => {
    if (!path || path === '/') return basePath;
    return `${basePath}${path.startsWith('/') ? '' : '/'}${path}`;
  };
  return (
    <MosqueContext.Provider value={{ mosque, mosqueId: mosque.id, basePath, to }}>
      {children}
    </MosqueContext.Provider>
  );
};
